export default "__VITE_ASSET__039426bd__"